import React from "react";
import { Card, CardHeader, CardBody, Row, Col } from "reactstrap";

const cardShell = {
  background: "var(--vz-secondary-bg, #fff)",
  border: "1px solid var(--vz-border-color)",
  borderRadius: 10,
  boxShadow: "0 1px 4px rgba(0,0,0,0.06)",
  overflow: "hidden",
};

const pageIconWrapStyle = {
  width: 32,
  height: 32,
  borderRadius: 8,
  border: "1px solid rgba(var(--vz-primary-rgb), 0.35)",
  background: "rgba(var(--vz-primary-rgb), 0.08)",
  display: "inline-flex",
  alignItems: "center",
  justifyContent: "center",
  flexShrink: 0,
};

const pageIconStyle = {
  color: "var(--vz-primary)",
  fontSize: 16,
};

const SupplyChainRisk = () => {
  return (
    <Card style={{ ...cardShell, border: "1px solid rgba(255,255,255,0.05)" }} className="h-100">

      <CardHeader className="bg-light">
        <h5 className="card-title mb-0">
          <div style={pageIconWrapStyle} className="me-2">
            <i className=" ri-truck-line " style={pageIconStyle} ></i>
          </div>
          Supply Chain & Third-Party Risk
        </h5>
      </CardHeader>

      <CardBody>

        <Row>

          {/* Left side */}
          <Col md={6}>

            <div className="mb-3">
              <p className="text-muted mb-1">VENDOR REMOTE SESSIONS</p>

              <h3 className="mb-1">03</h3>

              <span
                style={{
                  background: "rgba(249,115,22,0.15)",
                  color: "#f97316",
                  fontSize: "11px",
                  padding: "3px 10px",
                  borderRadius: "999px",
                  fontWeight: "600"
                }}
              >
                ACTIVE
              </span>
            </div>

            <div>
              <p className="text-muted mb-1">
                THIRD-PARTY ELEVATED PRIVS
              </p>

              <h3 className="mb-1">12</h3>

              <span className="text-muted" style={{ fontSize: "12px" }}>
                REVIEW NEEDED
              </span>
            </div>

          </Col>

          {/* Right side */}
          <Col md={6}>

            <div
              style={{
                border: "1px solid rgba(255,255,255,0.06)",
                borderRadius: "6px",
                padding: "12px",
                textAlign: "center"
              }}
            >
              <p className="text-muted mb-2">
                EXTERNAL MAINTENANCE ATTEMPTS
              </p>

              <div
                className="d-flex justify-content-center gap-1 mb-2"
              >
                {[1, 2, 3, 4, 5, 6].map((i) => (
                  <div
                    key={i}
                    style={{
                      width: "10px",
                      height: "28px",
                      background: i <= 3 ? "#ef4444" : "rgba(255,255,255,0.15)",
                      borderRadius: "2px"
                    }}
                  />
                ))}
              </div>

              <small className="text-muted">
                Blocked in Last 24 Hours
              </small>

            </div>

          </Col>

        </Row>

      </CardBody>

    </Card>
  );
};

export default SupplyChainRisk;